export default `
query sitePages{ 
    sitePages{
   _id
    slug
    content
    }
  }
`;
